module.exports = __webpack_public_path__ + "static/img/catering.9857722f.png";